import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-900bb1b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap_screen" }
const _hoisted_2 = { class: "tabbar" }
const _hoisted_3 = { class: "back" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Back", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "other_profile" }, " 채팅 커스텀 보이스 ", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  focusable: "false",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  color: "white",
  class: "eyeqlp51 st-emotion-cache-fblp2m ex0cdmw0"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M10.25 13a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM15 11.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5zm7 .25c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2s10 4.48 10 10zM10.66 4.12C12.06 6.44 14.6 8 17.5 8c.46 0 .91-.05 1.34-.12C17.44 5.56 14.9 4 12 4c-.46 0-.91.05-1.34.12zM4.42 9.47a8.046 8.046 0 003.66-4.44 8.046 8.046 0 00-3.66 4.44zM20 12c0-.78-.12-1.53-.33-2.24-.7.15-1.42.24-2.17.24a10 10 0 01-7.76-3.69A10.016 10.016 0 014 11.86c.01.04 0 .09 0 .14 0 4.41 3.59 8 8 8s8-3.59 8-8z" })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  focusable: "false",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  color: "white",
  class: "eyeqlp51 st-emotion-cache-fblp2m ex0cdmw0"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zm-2 10H6V7h12v12zm-9-6c-.83 0-1.5-.67-1.5-1.5S8.17 10 9 10s1.5.67 1.5 1.5S9.83 13 9 13zm7.5-1.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5zM8 15h8v2H8v-2z" })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "message" }
const _hoisted_13 = {
  class: "input-box",
  style: {"position":"relative"}
}
const _hoisted_14 = ["onKeydown"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "30",
    height: "30",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    focusable: "false",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    color: "#A3A8B9",
    class: "eyeqlp51 st-emotion-cache-fblp2m ex0cdmw0"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M3 5.51v3.71c0 .46.31.86.76.97L11 12l-7.24 1.81c-.45.11-.76.51-.76.97v3.71c0 .72.73 1.2 1.39.92l15.42-6.49c.82-.34.82-1.5 0-1.84L4.39 4.58C3.73 4.31 3 4.79 3 5.51z" })
  ])
], -1))
const _hoisted_16 = [
  _hoisted_15
]

import {
  useRouter,
  useRoute,
} from 'vue-router';
import {
  ref,
  onMounted,
  computed,
} from 'vue';
import { useSpeechRecognitionStore } from '../stores/storeSpeechRecognition';
import { userStore } from '../stores/storeAuth';
import {
  deleteLocalStorage,
  deleteStorage,
} from '@utils/storageUtils';
import { pushPage } from '@utils/route.helper';
import { errorDataType } from '@interface/error';
import { postUserSignout } from '@apis/auth';

interface Message {
  text: string,
  from: 'me' | 'other',
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomVoiceChat',
  setup(__props) {

const userData = userStore();
const currentPage = ref('');
const isFold = ref(true);
const foldMenu = () => {
  isFold.value = !isFold.value;
};

const isFoldManager = ref(true);
const foldMenuManager = () => {
  isFoldManager.value = !isFoldManager.value;
};
const route = useRoute();

const currentSecondNav = ref('');

const getSecondNavStyle = (value: string) => {
  const data = route.name;
  return { select_second_nav: data === value };
};

const selectCurrentSecondNav = (value: string) => {
  currentSecondNav.value = value;
  pushPage(`${value}`);
};

const messages = ref<Message[]>([]);
const newMessage = ref<string>('');
const chatScreenRef = ref<HTMLElement | null>(null);

const scrollToBottom = () => {
  if (chatScreenRef.value) {
    chatScreenRef.value.scrollTop = chatScreenRef.value.scrollHeight;
  }
};

const message = ref('');
const speakingStyle = ref('');
const persona = ref({
  world: '우주 외계 행성',
  era: '미래',
  place: '지구',
  happenings: '오염과 자연 파괴',
  name: '마징가',
  age: '30',
  tribe: '로봇',
  gender: '남자',
  work: '정착',
  goal: '평화로운 삶',
  value: '자연',
  motivation: '자연보호',
  personality: '평화롭고 자상하며 이야기를 잘 들어주는',
  mbti: 'INTJ',
  favorite: '자연의 동물과 식물',
  specialty: '산책, 그림 그리기',
  topic: '자연보호',
  speaking_habits: '"징가~"',
});

const botMessage = ref('');
const postRequestChat = async () => {
  const params = {
    user_message: newMessage.value,
    speaking_style: speakingStyle.value,
    persona: persona.value,
  };
  try {
    if (newMessage.value.trim() !== '') {
      messages.value.push({
        text: newMessage.value,
        from: 'me',
      });
    }
    newMessage.value = '';
    // const result = await postChat(userData.userId, params);
    // console.log(result.data.answer, '💛💛💛💛💛💛💛💛');
    // botMessage.value = result.data.answer;

    messages.value.push({
      text: botMessage.value,
      from: 'other',
    });

    setTimeout(() => {
      scrollToBottom();
    }, 100);

    setTimeout(() => {
      scrollToBottom();
    }, 600);
    // }
  } catch (error) {
    // AntNotification.error({ message: error.message });
  }
};

// const sendMessage = () => {
//   postRequestChat();
//   // if (newMessage.value.trim() !== '') {
//   //   messages.value.push({
//   //     text: newMessage.value,
//   //     from: 'me',
//   //   });
//   //   newMessage.value = '';

//   //   setTimeout(() => {
//   //     messages.value.push({
//   //       text: botMessage.value,
//   //       from: 'other',
//   //     });
//   //   }, 500);

//   //   setTimeout(() => {
//   //     scrollToBottom();
//   //   }, 100);

//   //   setTimeout(() => {
//   //     scrollToBottom();
//   //   }, 600);
//   // }
// };
const sendMessage = () => {
  postRequestChat();
};

const speechRecognitionStore = useSpeechRecognitionStore();

const handleSpeechResult = (spokenText: string | null) => {
  if (spokenText) {
    newMessage.value = spokenText;
    sendMessage();
  }
};

const startSpeechListening = () => {
  speechRecognitionStore.startSpeechRecognition(handleSpeechResult);
};

const stopSpeechListening = () => {
  speechRecognitionStore.stopSpeechRecognition();
};

const isListening = computed(() => speechRecognitionStore.isListening);
// const newMessage = ref<string>('');
// const isListening = ref(false);
// // eslint-disable-next-line
// const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
// const recognition = new SpeechRecognition();
// recognition.lang = 'ko-KR'; // Set the language to Korean

// const startSpeechRecognition = () => {
//   recognition.value = new SpeechRecognition();
//   recognition.value.lang = 'ko-KR';

//   recognition.value.onstart = () => {
//     console.log('Speech recognition started');
//     isListening.value = true;
//   };

//   recognition.value.onend = () => {
//     console.log('Speech recognition ended');
//     isListening.value = false;
//     sendMessage();
//   };

//   recognition.value.onerror = (event: any) => {
//     console.error('Speech recognition error:', event.error);
//   };

//   recognition.value.onresult = (event: any) => {
//     const confidenceThreshold = 0.5; // Adjust as needed
//     const spokenText = event.results[0][0].transcript;
//     const { confidence } = event.results[0][0];
//     const { transcript } = event.results[0][0];
//     newMessage.value = transcript;
//     console.log('Spoken Text:', spokenText);
//     console.log('Confidence:', confidence);

//     if (confidence >= confidenceThreshold) {
//       console.log('Spoken Text:', spokenText);
//       console.log('Confidence:', confidence);
//       newMessage.value = transcript;
//     } else {
//       console.log('Speech confidence below threshold. Ignoring result.');
//     }

//     // Your logic to handle the spoken text...
//     // For example, you can update a ref or send a message
//   };

//   recognition.value.start();
// };

// const stopSpeechRecognition = () => {
//   recognition.value?.stop();
//   isListening.value = false;
// };


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_font_awesome_icon, {
          class: "chevron",
          icon: "fa-solid fa-chevron-left"
        }),
        _hoisted_4
      ]),
      _hoisted_5,
      _createVNode(_component_font_awesome_icon, {
        class: "chevron",
        icon: "fa-solid fa-bars"
      })
    ]),
    _createElementVNode("div", {
      ref_key: "chatScreenRef",
      ref: chatScreenRef,
      class: "chat_screen"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("div", {
            class: _normalizeClass(["wrap_icon_message", { 'other': message.from !== 'me', 'me': message.from === 'me' }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass({ 'other_icon': message.from !== 'me', 'my_icon': message.from === 'me' })
            }, [
              (message.from === 'me')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _hoisted_8))
                : (_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_11))
            ], 2),
            _createElementVNode("div", _hoisted_12, _toDisplayString(message.text), 1)
          ], 2)
        ]))
      }), 128))
    ], 512),
    _createElementVNode("div", _hoisted_13, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newMessage).value = $event)),
        class: "input",
        placeholder: "입력해주세요.",
        onKeydown: _withKeys(_withModifiers(sendMessage, ["shift","prevent"]), ["enter"]),
        onKeyup: _withKeys(sendMessage, ["enter"])
      }, null, 40, _hoisted_14), [
        [_vModelText, newMessage.value]
      ]),
      _createElementVNode("button", {
        class: "button_send",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (sendMessage()))
      }, _hoisted_16),
      _createElementVNode("div", null, [
        (!isListening.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "button_rec",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (startSpeechListening()))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-microphone" })
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "button_rec",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (stopSpeechListening()))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-square" })
            ]))
      ])
    ])
  ]))
}
}

})